// src/Kanbas/Account/Navigation.tsx
import { Link } from "react-router-dom";

export default function AccountNavigation() {
  return (
    <div id="wd-account-navigation">
      {/* Navigation links for the Account section */}
      <Link to={`/Kanbas/Account/Signin`}>Signin</Link> <br />
      <Link to={`/Kanbas/Account/Signup`}>Signup</Link> <br />
      <Link to={`/Kanbas/Account/Profile`}>Profile</Link> <br />
    </div>
  );
}